import * as RTK from '@reduxjs/toolkit';
import { PropertyValue } from '../components/configuration/types';

export type State = {
    startingSelections: Record<string, PropertyValue> | undefined;
    startingAttachments: Record<string, string> | undefined;
    configuratorId: string | undefined;
};

const initialState: State = {
    startingSelections: undefined,
    startingAttachments: undefined,
    configuratorId: undefined,
};

export const slice = RTK.createSlice({
    name: 'configurations',
    initialState,
    reducers: {
        setInitialConfiguration(_state, action: RTK.PayloadAction<State>) {
            return action.payload;
        },
    },
});

export const { setInitialConfiguration } = slice.actions;

export const reducer = slice.reducer;
